let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iNILV")).then(() => parcelRequire('jsoDk'));